import { supabase } from "@fd/supabase/index";
import { googleLogout } from "@react-oauth/google";
import { gleap } from "../gleap";

export async function logout() {
  delete localStorage.userContext;
  googleLogout();
  gleap?.clearIdentity();
  await supabase.auth.signOut();
  await supabase.auth.refreshSession();
  window.location.href = "/account/signin"
}